
export default {
  data() {
    return {
      lazyLoadImg: false,
      input: '',
      debouncedInput: '',
      timeout: null,
    }
  },
  watch: {
    input(val) {
      if (this.timeout) clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.debouncedInput = val
      }, 300)
    },
    debouncedInput(val) {
      this.$nextTick(() => {
        function getTags(i = 0) {
          if (i === 5 || !val) {
            return
          }

          const tags = document.querySelectorAll('.st-query-present a')

          if (tags.length) {
            tags.forEach(function (elem) {
              elem.addEventListener('click', () => {
                parent.location.href = elem.href
              })
            })
          } else {
            setTimeout(() => {
              getTags(i + 1)
            }, 500)
          }
        }

        setTimeout(() => {
          getTags()
        }, 800)
      })
    },
  },
  mounted() {
    setTimeout(() => {
      this.lazyLoadImg = true
    }, 1500)
    // this.getQueryContainers()
  },

  methods: {
    debounce(fn, delay) {
      let timeoutID = null
      return function () {
        clearTimeout(timeoutID)
        const args = arguments
        const that = this
        timeoutID = setTimeout(function () {
          fn.apply(that, args)
        }, delay)
      }
    },
    // getQueryContainers(i = 0) {
    //   if (i === 10) {
    //     return
    //   }

    //   const queryContainers = document.querySelectorAll('.st-query-present')

    //   if (queryContainers.length < 1) {
    //     setTimeout(() => {
    //       this.getQueryContainers(i + 1)
    //     }, 500)
    //   } else {
    //     this.setUpObserver(queryContainers)
    //   }
    // },
    // setUpObserver(queryContainers = []) {
    //   if (queryContainers.length < 1) return

    //   // Options for the observer (which mutations to observe)
    //   const config = { childList: true }

    //   queryContainers.forEach((queryContainer) => {
    //     // create an observer instance
    //     const observer = new MutationObserver((mutations) => {
    //       mutations.forEach((mutation) => {
    //         if (mutation.type === 'childList') {
    //           const node = mutation.addedNodes[0]

    //           if (node && parent.location.hash) {
    //             // modal query container
    //             node.setAttribute('target', '_blank')
    //             return
    //           }

    //           if (node) {
    //             node.addEventListener('click', () => {
    //               parent.location.href = node.href
    //             })
    //           }
    //         }
    //       })
    //     })

    //     // pass in the target node, as well as the observer options
    //     observer.observe(queryContainer, config)
    //   })
    // },
  },
}
